<template>
    <div class="main-container">
        <AppToolbar></AppToolbar>
        <Navigation></Navigation>
        <v-content>
            <v-container fluid class="mb-0 pb-0" v-if="isTrial">
                <v-alert
                    :value="true"
                    color="primary"
                    :dismissible="true"
                    type="info"
                    class="pa-2"
                    outline
                >
                    Your account free trial version is allowed to make free 5 calls. For further information,
                    please contact us by email: support@fpt.ai / hotline: 0911886353
                </v-alert>
            </v-container>
            <v-fade-transition :hide-on-leave="true" :leave-absolute="true">
                <router-view></router-view>
            </v-fade-transition>
        </v-content>
    </div>
</template>
<script>
import {mapState} from 'vuex'
import AppToolbar from './AppToolbar.vue'
import Navigation from './Navigation'
import RoleMixin from '@/modules/fptai/mixins/RoleMixin'

export default {
    name: 'ProjectTemplate',
    mixins: [RoleMixin],
    components: {
        AppToolbar, Navigation
    },
    computed: {
        ...mapState({
            token: state => state.user.token
        }),
        isTrial: {
            get() {
                if (process.env.VUE_APP_AUTHENTICATION === 'self') {
                    return false
                }
                if (this.isAdmin) {
                    return false
                }
                return true
            }
        }
    }
}
</script>
<style scoped lang="scss">
.active_navigation i, .active_navigation .v-list__tile__title {
    color: #1976d2 !important;
    /*font-weight: bold;*/
}

.active_navigation .v-list__tile__title {
    font-weight: bold;
}

.main-container {
    background: #F7F9FD;
    min-height: 100%;
}

::v-deep {
    .v-toolbar .v-toolbar__content {
        padding: 0 12px !important;
    }

    .main-nav .v-list .v-list__tile:not(.v-list__tile--avatar) {
        height: 44px !important;
    }

    .theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {
        background-color: #E4EDFA !important;
    }

    div.jsoneditor {
        border: 1px solid #D9D9D9 !important;
    }
}
</style>
